import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=fa71801a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa71801a')) {
      api.createRecord('fa71801a', component.options)
    } else {
      api.reload('fa71801a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=fa71801a&", function () {
      api.rerender('fa71801a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24VdUYHRCzZxf/JS/comp/FavElement.vue"
export default component.exports